<template>
  <div>
    <b-spinner class="m-4" v-if="isUpdating" />
    <div v-else>
      <h1>{{ $t('setup.continue') }}</h1>
      <h2 v-if="sn !== ''" class="pb-1 serial">
        <img class="pr-1" src="../assets/sensor.svg">
        <b>{{ sn }}</b>
      </h2>
      <p>{{ $t('setup.computerConnected') }}</p>
      <div v-if="online">
        <p>{{ $t('setup.sensorOnline') }}</p>
        <p>
          <a href="#" v-on:click="$emit('continue_setup')">{{ $t('configureWifiLink') }}</a>
        </p>
        <b-button v-if="sn === ''" variant="primary" v-on:click="$emit('register')">{{ $t('register') }}</b-button>
        <!-- <b-button v-else variant="primary" v-on:click="$emit('continue_setup')">{{ $t('configureWifi') }}</b-button> -->
      </div>
      <div v-else>
        <p>{{ $t('setup.sensorOffline') }}</p>
        <b-button variant="primary" v-on:click="$emit('continue_setup')">{{ $t('configureWifi') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SetupStart',
  props: ['mac', 'sn'],
  mounted () {
    this.getOnlineStatus();
  },
  data() {
    return {
      online: false,
      isUpdating: true,
    }
  },
  methods: {
    getOnlineStatus() {
      axios
        .get('http://10.3.141.1:6762/api/v1/online')
        .then(response => {
          if (response.status == 200) {
            this.online = response.data.status;
          }
        })
        .finally(() => {
          this.isUpdating = false;
        });
    }
  }
}
</script>

<style>
.serial {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style scoped>
.serial > img {
  height: 36px;
}
</style>
